module.exports = __webpack_public_path__ + "img/下对齐2.c1b4f282.svg";